module.exports = __webpack_public_path__ + "img/51626517_L.87acc8a4.png";